// extracted by mini-css-extract-plugin
export default {"main":"ProjectsComponent_main__Ac1MN","maindiv":"ProjectsComponent_maindiv__F5iA5","icon":"ProjectsComponent_icon__WVqAZ"};